// extracted by mini-css-extract-plugin
module.exports = {"container":"clause-section_container__ndtHK","title":"clause-section_title__7qwA1"};